// this file combines together all the reducers into a single data store

import {combineReducers} from '@reduxjs/toolkit';
import communityPhotosReducer from './communityPhotos.reducer';

import dailyChallengesReducer from './dailyChallenges.reducer';
import eventReducer from './event.reducer';
import firstVisitReducer from './firstVisit.reducer';
import gameReducer from './game.reducer';
import gameV2Reducer from 'src/Redux/reducers/game_v2.reducer';
import groupInfoReducer from './groupInfo.reducer';
import homeReducer from './home.reducer';
import huntsReducer from './hunts.reducer';
import localReducer from './local.reducer';
import nearby from './nearby.reducer';
import saveAppInfoReducer from './app_info.reducer';
import badgesInfoReducer from './badges.reducer';
import saveCurrentScreenReducer from './current_screen.reducer';
import saveTicketValuesReducer from './ticket_vouchers.reducer';
import saveUserInfoReducer from './user_info.reducer';
import saveUserLocationReducer from './user_location.reducer';
import screenShotReducer from './screenShot.reducer';
import themesReducer from './themes.reducer';

const appReducer = combineReducers({
  app_info: saveAppInfoReducer,
  badges: badgesInfoReducer,
  communityPhotos: communityPhotosReducer,

  current_screen: saveCurrentScreenReducer,
  dailyChallenges: dailyChallengesReducer,
  event: eventReducer,
  firstVisit: firstVisitReducer,
  game: gameReducer,
  game_v2: gameV2Reducer,
  groupInfo: groupInfoReducer,
  home: homeReducer,
  hunts: huntsReducer,
  local: localReducer,
  location: saveUserLocationReducer,
  nearby,
  screenShot: screenShotReducer,
  themeInfo: themesReducer,
  ticket_vouchers: saveTicketValuesReducer,
  user: saveUserInfoReducer,
});

// adds a way to reset everything
const rootReducer = (state, action) => {
  // console.log({action});
  if (action.type === 'HARD_RESET') {
    console.log('RESETING ALL REDUCERS');
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
